var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenDoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 108,
    viewBox: "0 0 85 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9708 6.16895H16.3098V100.692H63.9708V6.16895Z",
    fill: "url(#paint0_linear_1068_27320)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 69.8421L7.03104 73.1033V91.4071L17.1496 87.4938V69.8421Z",
    fill: "url(#paint1_linear_1068_27320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 69.8421L7.03104 73.1033V91.4071L17.1496 87.4938V69.8421Z",
    fill: "url(#paint2_linear_1068_27320)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 12.1605L7.03104 9.55154V36.6912L17.1496 35.3867V12.1605Z",
    fill: "url(#paint3_linear_1068_27320)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 12.1605L7.03104 9.55154V36.6912L17.1496 35.3867V12.1605Z",
    fill: "url(#paint4_linear_1068_27320)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.17635 0.972656L20.0406 6.1905L20.5225 6.84273V100.112L3.17635 107.286V0.972656ZM7.03104 9.55154L17.1496 12.1605V35.3867L7.03104 36.6912V9.55154ZM17.1496 69.8421L7.03104 73.1033V91.4071L17.1496 87.4938V69.8421Z",
    fill: "#E1AE81"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17635 0.972656V107.286L1.73084 106.634V1.62489L3.17635 0.972656Z",
    fill: "#946A47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 39.7825L7.03104 41.7392V67.8854L17.1496 64.6243V39.7825Z",
    fill: "url(#paint5_linear_1068_27320)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1496 39.7825L7.03104 41.7392V67.8854L17.1496 64.6243V39.7825Z",
    fill: "url(#paint6_linear_1068_27320)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17635 0.972656L20.0406 6.1905L20.5225 6.84273V100.112L3.17635 107.286M3.17635 0.972656V107.286M3.17635 0.972656L1.73084 1.62489V106.634L3.17635 107.286M17.1496 12.1605L7.03104 9.55154V36.6912L17.1496 35.3867V12.1605ZM17.1496 69.8421L7.03104 73.1033V91.4071L17.1496 87.4938V69.8421ZM17.1496 39.7825L7.03104 41.7392V67.8854L17.1496 64.6243V39.7825Z",
    stroke: "#453D3D",
    strokeWidth: 0.851088
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12003 50.2139C5.6426 50.2139 6.06623 50.8163 6.06623 51.5595V67.3159C6.06623 68.059 5.6426 68.6615 5.12003 68.6615C4.59746 68.6615 4.17383 68.059 4.17383 67.3159V51.5595C4.17383 50.8163 4.59746 50.2139 5.12003 50.2139Z",
    fill: "#644F3D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.3422 50.2139C0.819625 50.2139 0.395996 50.8163 0.395996 51.5595V67.3159C0.395996 68.059 0.819625 68.6615 1.3422 68.6615V50.2139Z",
    fill: "#644F3D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5446 100.108L3.31006 107.343L1.55469 106.651V94.9487L3.31006 95.4806L20.5446 88.6719V100.108Z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31006 95.4806V107.343M3.31006 95.4806L20.5446 88.6719V100.108L3.31006 107.343M3.31006 95.4806L1.55469 94.9487V106.651L3.31006 107.343",
    stroke: "#453D3D",
    strokeWidth: 0.851088,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7342 69.8421L77.8528 73.1033V91.4071L67.7342 87.4938V69.8421Z",
    fill: "url(#paint7_linear_1068_27320)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7342 69.8421L77.8528 73.1033V91.4071L67.7342 87.4938V69.8421Z",
    fill: "url(#paint8_linear_1068_27320)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7342 12.1605L77.8528 9.55154V36.6912L67.7342 35.3867V12.1605Z",
    fill: "url(#paint9_linear_1068_27320)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7342 12.1605L77.8528 9.55154V36.6912L67.7342 35.3867V12.1605Z",
    fill: "url(#paint10_linear_1068_27320)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7074 0.972656L64.8432 6.1905L64.3613 6.84273V100.112L81.7074 107.286V0.972656ZM77.8528 9.55154L67.7342 12.1605V35.3867L77.8528 36.6912V9.55154ZM67.7342 69.8421L77.8528 73.1033V91.4071L67.7342 87.4938V69.8421Z",
    fill: "#E1AE81"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7074 0.972656V107.286L83.153 106.634V1.62489L81.7074 0.972656Z",
    fill: "#946A47"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7342 39.7825L77.8528 41.7392V67.8854L67.7342 64.6243V39.7825Z",
    fill: "url(#paint11_linear_1068_27320)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7342 39.7825L77.8528 41.7392V67.8854L67.7342 64.6243V39.7825Z",
    fill: "url(#paint12_linear_1068_27320)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7074 0.972656L64.8432 6.1905L64.3613 6.84273V100.112L81.7074 107.286M81.7074 0.972656V107.286M81.7074 0.972656L83.153 1.62489V106.634L81.7074 107.286M67.7342 12.1605L77.8528 9.55154V36.6912L67.7342 35.3867V12.1605ZM67.7342 69.8421L77.8528 73.1033V91.4071L67.7342 87.4938V69.8421ZM67.7342 39.7825L77.8528 41.7392V67.8854L67.7342 64.6243V39.7825Z",
    stroke: "#453D3D",
    strokeWidth: 0.851088
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7638 50.2139C79.2412 50.2139 78.8176 50.8163 78.8176 51.5595V67.3159C78.8176 68.059 79.2412 68.6615 79.7638 68.6615C80.2863 68.6615 80.71 68.059 80.71 67.3159V51.5595C80.71 50.8163 80.2863 50.2139 79.7638 50.2139Z",
    fill: "#644F3D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3233 100.108L81.5579 107.343L83.3132 106.651V94.9487L81.5579 95.4806L64.3233 88.6719V100.108Z",
    fill: "#B3B3B3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5579 95.4806V107.343M81.5579 95.4806L64.3233 88.6719V100.108L81.5579 107.343M81.5579 95.4806L83.3132 94.9487V106.651L81.5579 107.343",
    stroke: "#453D3D",
    strokeWidth: 0.851088,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8073 50.0557C84.3297 50.0557 84.7532 50.6581 84.7532 51.4013V67.1576C84.7532 67.9008 84.3297 68.5033 83.8073 68.5033V50.0557Z",
    fill: "#644F3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1068_27320",
    x1: 21.8419,
    y1: 8.29465,
    x2: 40.1206,
    y2: 100.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB8455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#795C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1068_27320",
    x1: 11.1266,
    y1: 107.286,
    x2: 11.1266,
    y2: 0.972656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1068_27320",
    x1: 11.1266,
    y1: 0.972656,
    x2: 11.1266,
    y2: 107.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1068_27320",
    x1: 11.1266,
    y1: 107.286,
    x2: 11.1266,
    y2: 0.972656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1068_27320",
    x1: 11.1266,
    y1: 0.972656,
    x2: 11.1266,
    y2: 107.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1068_27320",
    x1: 11.1266,
    y1: 107.286,
    x2: 11.1266,
    y2: 0.972656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1068_27320",
    x1: 11.1266,
    y1: 0.972656,
    x2: 11.1266,
    y2: 107.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1068_27320",
    x1: 73.7571,
    y1: 107.286,
    x2: 73.7571,
    y2: 0.972656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1068_27320",
    x1: 73.7571,
    y1: 0.972656,
    x2: 73.7571,
    y2: 107.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1068_27320",
    x1: 73.7571,
    y1: 107.286,
    x2: 73.7571,
    y2: 0.972656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1068_27320",
    x1: 73.7571,
    y1: 0.972656,
    x2: 73.7571,
    y2: 107.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1068_27320",
    x1: 73.7571,
    y1: 107.286,
    x2: 73.7571,
    y2: 0.972656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#946A47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E2116"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1068_27320",
    x1: 73.7571,
    y1: 0.972656,
    x2: 73.7571,
    y2: 107.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#768E99"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDoor);
export default __webpack_public_path__ + "static/media/OpenDoor.0786b5aa62e603e7cdcd.svg";
export { ForwardRef as ReactComponent };